import { Component, OnDestroy, OnInit } from '@angular/core'
import { Router } from '@angular/router'
import { AuthService } from '@shared/services/auth.service'
import { FormGroup, FormControl, Validators } from '@angular/forms'
import { Subscription } from 'rxjs'
import { PublicPageTitleService } from '@public/app/services/public-page-title.service'
import { LoadingIndicatorService } from '../../services/loading-indicator.service'
import { ToastService } from '../../services/toast.service'

@Component({
  selector: 'app-login-page',
  templateUrl: './login-page.component.html',
  styleUrls: ['./login-page.component.scss'],
})
export class LoginPageComponent implements OnInit, OnDestroy {
  loginForm: FormGroup
  subscriptions: Subscription[] = []
  pageTitle = 'Bejelentkezés'

  constructor(
    private authService: AuthService,
    private router: Router,
    private publicPageTitleService: PublicPageTitleService,
    private loadingIndicatorService: LoadingIndicatorService,
    private toastService: ToastService
  ) {
    this.loginForm = new FormGroup({
      email: new FormControl('', [Validators.required, Validators.email]),
      password: new FormControl('', Validators.required),
    })
    this.publicPageTitleService.setPageTitle(this.pageTitle)
  }

  ngOnDestroy(): void {
    this.subscriptions.forEach(subscription => subscription.unsubscribe())
  }

  ngOnInit(): void {
    this.subscriptions.push(
      this.authService.userLoggedinEvent.subscribe(isLoggedIn => {
        isLoggedIn ? this.router.navigate(['/']) : this.router.navigate(['/Login'])
      })
    )
  }

  onLogin(): void {
    if (this.loginForm.valid) {
      this.loadingIndicatorService.showLoading()
      this.authService
        .signInWithEmailAndPassword(this.loginForm.value.email, this.loginForm.value.password)
        .then(result => {
          let credential = result.credential
          let user = result.user
          this.toastService.showSuccess('Helló az önkénteskedés világában ' + user.displayName)
        })
        .catch(error => {
          let errorCode = error.code
          let errorMessage = error.message
          let email = error.email
          let credential = error.credential
          console.error('Email/jelszó alapú belépés hiba: ', error)
          this.toastService.showError('Hoppá, úgy nézki, hogy nem jó felhasználónevet vagy jelszót adtál meg.')
        })
        .finally(() => {
          this.loadingIndicatorService.hideLoading()
        })
    }
  }

  navigateToRegister(): void {
    this.router.navigate(['/register'])
  }

  navigateToForgottenPassword(): void {
    this.router.navigate(['/forgotten-password'])
  }
}